import React from 'react';
import AttributesDialog from '..';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useFocusedAttribute } from '../hooks/useFocusedAttribute';
import { Modes } from '../../../redux/reducers/focusedAttributeReducer';
import ActionButton from './NewSubmit';

const NewAttributeDialog: React.FC = () => {
  const { attribute, handleClose } = useFocusedAttribute(Modes.NEW);

  const { brands } = useSelector((state: RootStateOrAny) => state.UserReducer);
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const brand = brands.find(({ brandCode }) => brandCode === selectedBrand);

  if (!attribute) return null;

  return (
    <AttributesDialog
      open
      onClose={handleClose}
      titleKey="attributes.modal.titleNew"
      subtitleKey="attributes.modal.subtitleNew"
      ActionButton={ActionButton}
      {...attribute}
      brand={brand}
    />
  );
};

export default NewAttributeDialog;
